module.exports = __webpack_public_path__ + "img/yus.583b5ff1.png";